<template>
    <v-app :class="{ 'login-view': this.$route.name == 'Login' || this.$route.name == 'SignIn' || this.$route.name == 'ForgotPassword' || this.$route.name == 'ResetPassword' || this.$route.name == 'RegisterProfile' || this.$route.name == 'RegisterSuccess' || this.$route.name == 'RegisterSchool' || this.$route.name == 'RegisterSignOut' || this.$route.name == 'ProfileRegisterSignOut' || this.$route.name == 'RegisterOrganisation' || this.$route.name == 'OrganisationSignOut' || this.$route.name == 'RegisterSuccessOrganisation' }"
           :style="{ 'visibility': (isLoggedIn || this.$route.meta.requires_auth === false) ? 'visible' : 'hidden' }"
    >
        <v-main>
            <router-view></router-view>
        </v-main>
        <AppInstallDialog></AppInstallDialog>
        <BottomNavigation v-if="showNavigation"></BottomNavigation>
        <Snackbar></Snackbar>
    </v-app>
</template>


<script>
import Snackbar from "./components/layout/Snackbar";
import BottomNavigation from "./components/layout/BottomNavigation";
import {mapState} from "vuex";
import AppInstallDialog from "./components/layout/AppInstallDialog";

export default {
    components: {
        AppInstallDialog,
        Snackbar,
        BottomNavigation
    },
    computed: {
        showNavigation () {
            return (typeof this.$route.meta.show_navigation === 'undefined') || this.$route.meta.show_navigation !== false;
        },
        showBackButton () {
            return this.$route.meta.show_back_button === true;
        },
        ...mapState({
            isLoggedIn: state => state.auth.isLoggedIn,
        }),
    },
    watch: {
        isLoggedIn () {
            if (!this.isLoggedIn) {
                this.$router.push({name: 'Login'});
            }
        }
    },
    methods: {
        back () {
            if (window.history.length > 2) {
                this.$router.go(-1);
            } else if (this.isLoggedIn) {
                this.$router.push({name: 'Home'});
            } else {
                this.$router.push({name: 'Login'});
            }
        },
    },
}
</script>

<style lang="scss">
@import "assets/scss/app";
</style>
